"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _default = /*#__PURE__*/(0, _react.createContext)(null);

exports["default"] = _default;